const DIAMOND_HANDS_BONUS_GOLD = 15;
const DIAMOND_HANDS_BONUS_SILVER = 7;
const DIAMOND_HANDS_BONUS_BRONZE = 3;
const APY = 3678.3;
const APR = 365;
const DAILY_ROI = 1;
const MIN_PRICE = 10_000;
const MIN_MERGE_PRICE = 10;
const TOKEN_DECIMALS = 18;
const FEE_CLAIM = 30;
const FEE_COMPOUND = 15;
const REFERRAL_COMMISSION = 5;

const bonusList = [
	DIAMOND_HANDS_BONUS_GOLD,
	DIAMOND_HANDS_BONUS_SILVER,
	DIAMOND_HANDS_BONUS_BRONZE,
];

const title = "VaporNodes";
const vpndAddress = "0x83a283641C6B4DF383BCDDf807193284C84c5342";
const defaultRPC = "https://api.avax.network/ext/bc/C/rpc";
const nodeManagerAddress = "0x0be95e7cFD447E2Bb0057ed7143fdBE3b2847996";
const nodeManager02Address = "0x893107F0270631BC252aE17fB63c60C387e07BBc";
const vaporVotingAddress = "0x257D25E2eb4B9B08AEc98A359B62C4Db33edFD11";
const vaporManagerAddress = "0x0E613Ebc1598e889963e4AF450bfC2a70d390C96";
const nodeStorageAddress = "0x14F65b7e04eB0a11FD1D0a3bdB08311299ab6048";
const nodeControllerAddress = "0xa1Ce9Bb5563822E320e2f7832A5dF17A13B951aE";
const referralControllerAddress = "0x432ABca743Af5183BAAA83f86bE8CA793F5FF85d";
const vaporControllerAddress = "0x0efc8ef83d7318121449e9c5dbdf7135bcc1fa90";
const nodeController03Address = "0xD7Ce2935008Ae8ca17E90fbe2410D2DB7608058C";
const deepLinkingURL = "app.vapornodes.finance";
const vpndTokenDecimals = TOKEN_DECIMALS;
const nodeController02Address = "0xaC21437aA2402c1503B46DC24ccd676B51ce107d";
const vaporController02Address = "0xF964De4bf6EB0Ca9408F771f6921641b913f9255";
const nodeController04Address = "0xCd5E168dA3456cD2d5A8ab400f9cebdDC453720d";
const metricsAggregatorAddress = "0x6fb8f9bf44854427b9c966068151d8e0743ca76a";
const nodeController05Address = "0x0efc8ef83d7318121449e9c5dbdf7135bcc1fa90";
const stratosphereAddress = "0x08e287adCf9BF6773a87e1a278aa9042BEF44b60";
const rewardsPoolGDM = "0x8A0B27E6C2cb835e0ceEFD25Da5Fc8cC1a390514";

const UNSTOPPABLE_DOMAINS_ENV = process.env.NEXT_PUBLIC_UNSTOPPABLE_DOMAINS;

const FRONTEND_SUBGRAPH_URL =
	process.env.NEXT_PUBLIC_SUBGRAPH_URL ??
	"https://api.goldsky.com/api/public/project_cloh4i8580dwo2nz7brhf4r6p/subgraphs/vapornodes/1.0.0/gn";

const defaultConfig = {
	FRONTEND_SUBGRAPH_URL,
	UNSTOPPABLE_DOMAINS_ENV,
	appTokenomics: {
		apr: APR,
		apy: APY,
		claimFee: FEE_CLAIM,
		compoundFee: FEE_COMPOUND,
		dailyROI: DAILY_ROI,
		minMergePrice: MIN_MERGE_PRICE,
		minPrice: MIN_PRICE,
		referralCommission: REFERRAL_COMMISSION,
	},
	defaultRPC,
	diamondHandTier: (amount: number, differenceInDays: number) =>
		// amount and bonus could be set dynamically using env variables
		amount < 50_000 && defaultConfig.diamondHandsBonus.gold(differenceInDays)
			? { bonus: 0.3, tier: 3 }
			: amount < 500_000 &&
					defaultConfig.diamondHandsBonus.silver(differenceInDays)
				? { bonus: 0.1, tier: 2 }
				: defaultConfig.diamondHandsBonus.bronze(differenceInDays)
					? { bonus: 0.05, tier: 1 }
					: { bonus: 0, tier: 0 },
	diamondHandsBonus: {
		bonusList,
		bronze: (differenceInDays: number) => differenceInDays >= 20,
		gold: (differenceInDays: number) => differenceInDays >= 40, // REVERT BEFORE MERGE!
		silver: (differenceInDays: number) => differenceInDays >= 30,
	},
	documentation: {
		nodesTransformation:
			"https://vaporfi633.sharepoint.com/:b:/s/VaporFi/EYWH7sSW_LxDrfEqlcyp3ZEBFr8uFZbEctipYPGqRvCVew?e=qvEjla",
	},
	isDisabled: {
		claim: false,
	},
	pairAddress: {
		avaxPair: "0xf4003f4efbe8691b60249e6afbd307abe7758adb",
		vpndPair: "0x4cd20F3e2894Ed1A0F4668d953a98E689c647bfE",
	},
	social: {
		discord: "https://discord.gg/87XUXSeenu",
		twitter: "https://twitter.com/_VaporFi",
		youtube: "https://www.youtube.com/channel/UCAkH-iqZo5ZzBGcJoGmjSNQ",
	},
	title,
	validRPCs: ["https://api.avax.network/ext/bc/C/rpc"],
	vaporDEX: {
		app: "https://app.vapordex.io",
		home: "https://vapordex.io",
	},
	web3: {
		deepLinkingURL,
		metricsAggregatorAddress,
		nodeController02Address,
		nodeController03Address,
		nodeController04Address,
		nodeController05Address,
		nodeControllerAddress,
		nodeManager02Address,
		nodeManagerAddress,
		nodeStorageAddress,
		referralControllerAddress,
		rewardsPoolGDM,
		stratosphereAddress,
		vaporController02Address,
		vaporControllerAddress,
		vaporManagerAddress,
		vaporVotingAddress,
		vpndAddress,
		vpndTokenDecimals,
	},
};

export default defaultConfig;
